import { render, staticRenderFns } from "./ModalTutoUnsubscribe.vue?vue&type=template&id=627dd0b5&scoped=true&"
import script from "./ModalTutoUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./ModalTutoUnsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutoUnsubscribe.vue?vue&type=style&index=0&id=627dd0b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627dd0b5",
  null
  
)

component.options.__file = "ModalTutoUnsubscribe.vue"
export default component.exports